export const GEOMETRY = "geometry";
export const SNAPPED_FEATURE = "snappedFeature";
export const EDIT_ONGOING = "editOngoing";
export const HAVERSINE = "haversine";
export const VERTICES_ON_START = "verticesOnStartModify";
export const EDITING_CORRIDOR_WIDTH = "editingCorridorWidth";
